import { createTheme } from '@mui/material/styles';

// Create a theme instance with mode toggling support
export const createAppTheme = () => {
  return createTheme({
    colorSchemes: {
      dark: {
        palette: {
          tonalOffset: 0.3,
          contrastThreshold: 4,
          primary: {
            main: '#28793b'
          },
          secondary: {
            main: '#f50057'
          },
          error: {
            main: '#a32f2f'
          },
    
          warning: {
            main: '#ed6c02'
          },
    
          info: {
            main: '#03a9f4',
          },
    
          success: {
            main: '#2e7d32',
          },
        }
      },
      light: {
        palette: {
          tonalOffset: 0.3,
          contrastThreshold: 4,
          primary: {
            main: '#28793b'
          },
          secondary: {
            main: '#f50057'
          },
          error: {
            main: '#d32f2f'
          },
    
          warning: {
            main: '#ed6c02'
          },
    
          info: {
            main: '#03a9f4',
          },
    
          success: {
            main: '#2e7d32',
          },
        }
      }
    },

    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      h1: { fontWeight: 500, fontSize: '2.5rem' },
      h2: { fontWeight: 500, fontSize: '2rem' },
      h3: { fontWeight: 500, fontSize: '1.75rem' },
      h4: { fontWeight: 500, fontSize: '1.5rem' },
      h5: { fontWeight: 500, fontSize: '1.25rem' },
      h6: { fontWeight: 500, fontSize: '1rem' },
    },

    shape: {
      borderRadius: 8,
    },

    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
          },
        },
      },

      MuiCssBaseline: {
        styleOverrides: {
          '*': {
            transition: 'background-color 0.2s ease, color 0.2s ease',
          },
        },
      },
    },
  });
};
